
  import { Component, Prop, Vue } from "vue-property-decorator";
  import { SupportedProviders } from "@/interfaces";

  @Component
  export default class MarketplaceIcon extends Vue {
    @Prop({ required: true }) readonly marketplace!: SupportedProviders;
    @Prop({ required: true }) readonly state!: boolean;
  }
